export default __webpack_public_path__ + "static/media/Baboyakov.ccb2a5a2.png";